import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: `${config.appUrlPortal}${config.devAssetsFolder}/img/ball-notfound.png`,
    loading: `${config.appUrlPortal}${config.devAssetsFolder}/img/ball-loading.svg`, 
    attempt: 2
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/lazyLoad.js